<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2d"><a id="page_v"></a><a id="toc">Contents</a></h2><a id="toc">
</a><p class="toc"><a id="toc"></a><a class="nounder" href="#/xhtml/frontmatter">Acknowledgments</a></p>
<p class="tocd"><a class="nounder" href="#/xhtml/chapter1">1 Building the Synagogue Community in Colonial America: The Earliest Years</a></p>
<p class="tocd"><a class="nounder" href="#/xhtml/chapter2">2 Reforming Judaism Everywhere: Ushering in Change in the Nineteenth Century</a></p>
<p class="tocd"><span class="nounder" href="#/xhtml/chapter3" title="Link target outside of Sample">3 An Explosion of Immigrant Synagogues: Jewish Mass Migration to America</span></p>
<p class="tocd"><span class="nounder" href="#/xhtml/chapter4" title="Link target outside of Sample">4 Conservative and Orthodox Judaism Define Themselves: Between the Wars</span></p>
<p class="tocd"><span class="nounder" href="#/xhtml/chapter5" title="Link target outside of Sample">5 Expanding Suburbs and Synagogues: The Post–World War II Years</span></p>
<p class="tocd"><span class="nounder" href="#/xhtml/chapter6" title="Link target outside of Sample">6 Reinventing, Experimenting, and Racheting Up: Judaism after 1967</span></p>
<p class="toc"> </p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter" title="Link target outside of Sample">Appendix: Counting Synagogues</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter1" title="Link target outside of Sample">Sources</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter2" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/backmatter3" title="Link target outside of Sample">About the Author</span><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?31434a8f